import styled from 'styled-components';

export const OnboardingWelcomeSkeleton = styled.div`
    width: 100%;
    display: flex;
    justify-content: start;
    flex-flow: column;
    padding: 20px 0px;
`;

export const OnboardingWelcomeWrapper = styled.div<{ $hasWarnings: boolean }>`
    display: flex;
    flex-direction: column;
    padding-bottom: 32px;
    ${({ $hasWarnings }) => !$hasWarnings && `margin-top: 32px;`}
`;

export const OnboaringWelcomeHeader = styled.div`
    line-height: 40px;
`;

export const OnboaringWelcomeSubheader = styled.div`
    line-height: 24px;
`;
